import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20db05e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CajitaVentas"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cart4" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "col-12" }, "Ventas", -1))
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_5 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "table-dark" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "#", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "Fecha de la venta", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "Monto", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "Total de productos", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "Tipo de venta", -1))
const _hoisted_13 = {
  key: 0,
  scope: "col"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center"
}, "Detalles", -1))
const _hoisted_15 = {
  scope: "row",
  class: "text-center"
}
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "d-flex justify-content-evenly text-center" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "CajitaAgregarVenta"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "col-12 mb-4" }, "Agregar venta", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-8 col-sm-10 col-md-10 col-lg-11 col-xl-11 col-xxl-11 mb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "ProductSel",
  class: "form-label fw-semibold"
}, "Producto", -1))
const _hoisted_33 = {
  class: "form-select",
  "aria-label": "Default select example",
  id: "ProductSel"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  selected: ""
}, null, -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "col-4 col-sm-2 col-md-2 col-lg-1 col-xl-1 col-xxl-1 text-start mb-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label fw-semibold"
}, "Agregar", -1))
const _hoisted_38 = { class: "" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_42 = {
  key: 0,
  class: "row"
}
const _hoisted_43 = {
  key: 0,
  class: "row p-3 border bg-light"
}
const _hoisted_44 = { class: "col-9 col-sm-10 col-md-10 col-lg-11 col-xl-11 col-xxl-11 row" }
const _hoisted_45 = { class: "mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "NomProduct{{j}}",
  class: "form-label fw-semibold"
}, "Nombre del producto", -1))
const _hoisted_47 = ["id", "value"]
const _hoisted_48 = { class: "mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "ValUniProduct",
  class: "form-label fw-semibold"
}, "En inventario", -1))
const _hoisted_50 = ["id", "value"]
const _hoisted_51 = { class: "mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "CanProduct{{j}}",
  class: "form-label fw-semibold"
}, "Cantidad", -1))
const _hoisted_53 = ["max", "onChange", "id"]
const _hoisted_54 = { class: "mb-3 col-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 col-xxl-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "ValUniProduct",
  class: "form-label fw-semibold"
}, "Valor unitario", -1))
const _hoisted_56 = ["id", "value"]
const _hoisted_57 = { class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "TotProduct{{j}}",
  class: "form-label fw-semibold"
}, "Total", -1))
const _hoisted_59 = ["id", "value"]
const _hoisted_60 = { class: "mb-1 col-3 col-sm-2 col-md-2 col-lg-1 col-xl-1 col-xxl-1 d-flex justify-content-end align-items-center" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_65 = { class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label fw-semibold"
}, "Tipo de venta", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1 ",
  selected: ""
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Efectivo", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Tarjeta de crédito", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Tarjeta de débito", -1))
const _hoisted_71 = [
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4\" data-v-20db05e4><label for=\"DescripVent\" class=\"form-label fw-semibold\" data-v-20db05e4>Descripción</label><input type=\"text \" class=\"form-control\" id=\"DescripVent\" placeholder=\"\" data-v-20db05e4></div><div class=\"mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4\" data-v-20db05e4><label for=\"TotalVent\" class=\"form-label fw-semibold\" data-v-20db05e4>Total</label><input type=\"text \" class=\"form-control\" id=\"TotalVent\" placeholder=\"\" disabled data-v-20db05e4></div>", 2)
const _hoisted_74 = {
  key: 1,
  class: "row"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_76 = { class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "DineroEfect",
  class: "form-label fw-semibold"
}, "Dinero en efectivo", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "DineroCambio",
    class: "form-label fw-semibold"
  }, "Cambio"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control",
    id: "DineroCambio",
    placeholder: "$0.00",
    disabled: ""
  })
], -1))
const _hoisted_79 = {
  key: 0,
  class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"visibility":"hidden"} }, "-")
], -1))
const _hoisted_81 = { class: "d-grid gap-2" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash-coin" }, null, -1))
const _hoisted_83 = {
  key: 2,
  class: "mb-3 col-12 col-sm-12 col-md-12 col-lg-12 text-center"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"visibility":"hidden"} }, "-")
], -1))
const _hoisted_85 = { class: "" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash-coin" }, null, -1))
const _hoisted_87 = {
  key: 2,
  class: "Cargando"
}
const _hoisted_88 = /*#__PURE__*/_createStaticVNode("<div class=\"wrapper\" data-v-20db05e4><div class=\"circle circle1\" data-v-20db05e4></div><div class=\"circle circle2\" data-v-20db05e4></div><div class=\"circle circle3\" data-v-20db05e4></div><div class=\"shadow\" data-v-20db05e4></div><div class=\"shadow\" data-v-20db05e4></div><div class=\"shadow\" data-v-20db05e4></div><span data-v-20db05e4>Cargando</span></div>", 1)
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = {
  key: 3,
  class: "ModalVerVenta"
}
const _hoisted_91 = { class: "ContentMVVent" }
const _hoisted_92 = { class: "row g-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "col-12 mb-4 text-center" }, "Vista previa", -1))
const _hoisted_94 = {
  key: 0,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Vendedor:", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = { class: "placeholder form-label" }
const _hoisted_98 = {
  key: 1,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Tipo de pago:", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = { class: "placeholder form-label" }
const _hoisted_102 = {
  key: 2,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Total de la compra:", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_105 = { class: "placeholder form-label" }
const _hoisted_106 = {
  key: 3,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Tipo de pago:", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { class: "placeholder form-label" }
const _hoisted_110 = {
  key: 4,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Total de la compra:", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = { class: "placeholder form-label" }
const _hoisted_114 = { class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Fecha de la venta:", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_117 = { class: "placeholder form-label" }
const _hoisted_118 = {
  key: 5,
  class: "mb-3 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Descripción:", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_121 = { class: "placeholder form-label" }
const _hoisted_122 = {
  key: 6,
  class: "table-responsive col-12"
}
const _hoisted_123 = { class: "table" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "#")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Nombre del producto")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Cantidad")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Total")
      ])
    ])
  ])
], -1))
const _hoisted_125 = {
  scope: "row",
  class: "text-center"
}
const _hoisted_126 = { class: "placeholder-glow" }
const _hoisted_127 = { class: "placeholder form-label" }
const _hoisted_128 = { class: "text-center" }
const _hoisted_129 = { class: "placeholder-glow text-center" }
const _hoisted_130 = { class: "placeholder form-label" }
const _hoisted_131 = { class: "text-center" }
const _hoisted_132 = { class: "placeholder-glow" }
const _hoisted_133 = { class: "placeholder form-label" }
const _hoisted_134 = { class: "text-center" }
const _hoisted_135 = { class: "placeholder-glow" }
const _hoisted_136 = { class: "placeholder form-label" }
const _hoisted_137 = {
  key: 4,
  class: "ModalVerVenta"
}
const _hoisted_138 = { class: "ContentMVVent" }
const _hoisted_139 = { class: "row g-3" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "col-12 mb-4 text-center" }, "Editar venta", -1))
const _hoisted_141 = {
  key: 0,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Vendedor:", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_144 = { class: "placeholder form-label" }
const _hoisted_145 = { class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Tipo de pago:", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_148 = { class: "placeholder form-label" }
const _hoisted_149 = { class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Total de la compra:", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_152 = { class: "placeholder form-label" }
const _hoisted_153 = {
  key: 1,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Fecha de la venta:", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_156 = { class: "placeholder form-label" }
const _hoisted_157 = {
  key: 2,
  class: "mb-2 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
}
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Fecha de la venta:", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_160 = { class: "placeholder form-label" }
const _hoisted_161 = { class: "mb-3 placeholder-glow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Descripción:", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_164 = {
  key: 0,
  class: "placeholder form-label w-100"
}
const _hoisted_165 = ["value"]
const _hoisted_166 = {
  key: 3,
  class: "table-responsive col-12"
}
const _hoisted_167 = { class: "table" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "#")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Nombre del producto")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Cantidad")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-center"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "placeholder form-label fw-semibold" }, "Total")
      ])
    ])
  ])
], -1))
const _hoisted_169 = {
  scope: "row",
  class: "text-center"
}
const _hoisted_170 = { class: "placeholder-glow" }
const _hoisted_171 = { class: "placeholder form-label" }
const _hoisted_172 = { class: "text-center" }
const _hoisted_173 = { class: "placeholder-glow text-center" }
const _hoisted_174 = { class: "placeholder form-label" }
const _hoisted_175 = { class: "text-center" }
const _hoisted_176 = { class: "placeholder-glow" }
const _hoisted_177 = { class: "placeholder form-label" }
const _hoisted_178 = { class: "text-center" }
const _hoisted_179 = { class: "placeholder-glow" }
const _hoisted_180 = { class: "placeholder form-label" }
const _hoisted_181 = { class: "col-12 placeholder-glow text-center" }
const _hoisted_182 = { class: "d-grid gap-2 d-md-flex justify-content-md-center" }
const _hoisted_183 = {
  key: 0,
  href: "#",
  tabindex: "-1",
  class: "btn btn-primary placeholder disabled w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.VentasPrin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary float-end",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.VerAgregar()))
          }, [
            _hoisted_2,
            _createTextVNode(" Agregar")
          ]),
          _hoisted_3,
          (_ctx.dataVentas.length==0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No hay datos disponibles "))
            : _createCommentVNode("", true),
          (_ctx.dataVentas.length!=0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", null, [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12,
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_13, "Usuario"))
                        : _createCommentVNode("", true),
                      _hoisted_14
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataVentas, (VenPro, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("th", _hoisted_15, _toDisplayString(i + 1), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(VenPro.VEN_FECHA), 1),
                        _createElementVNode("td", _hoisted_17, "$" + _toDisplayString(VenPro.VEN_MONTO), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(VenPro.VEN_CANTIDAD), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(VenPro.VEN_TIPOPAGO), 1),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(VenPro.USU_NOMBRE), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-dark",
                              onClick: ($event: any) => (_ctx.VerDetallesVenta(i))
                            }, [
                              _hoisted_23,
                              _createTextVNode(" Ver")
                            ], 8, _hoisted_22),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-dark",
                              onClick: ($event: any) => (_ctx.EditarDetallesVenta(i))
                            }, [
                              _hoisted_25,
                              _createTextVNode(" Editar")
                            ], 8, _hoisted_24)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.VentAgregar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CerrarAgregar())),
            class: "btn btn-danger float-end"
          }, _hoisted_28),
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("select", _hoisted_33, [
                _hoisted_34,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Productos, (product, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: i
                  }, _toDisplayString(product.PRO_NOMBRE), 9, _hoisted_35))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: "btn btn-outline-dark",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.AgregarVenta('ProductSel'))),
                  type: "button"
                }, _hoisted_40)
              ])
            ]),
            _hoisted_41
          ]),
          (_ctx.dataProventa.length!=0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProventa, (producto, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-12 mb-3",
                    key: j
                  }, [
                    (producto.estatus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: 'NomProduct'+j,
                                placeholder: "",
                                value: producto.nombre,
                                disabled: ""
                              }, null, 8, _hoisted_47)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: 'ValUniProduct'+j,
                                placeholder: "",
                                value: producto.stock,
                                disabled: ""
                              }, null, 8, _hoisted_50)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("input", {
                                type: "number",
                                max: producto.stock,
                                min: "1",
                                class: "form-control",
                                onChange: ($event: any) => (_ctx.TotalProducto(j,'CanProduct','TotProduct')),
                                id: 'CanProduct'+j,
                                placeholder: "0",
                                value: "1"
                              }, null, 40, _hoisted_53)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                id: 'ValUniProduct'+j,
                                placeholder: "",
                                value: producto.precio,
                                disabled: ""
                              }, null, 8, _hoisted_56)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("input", {
                                type: "number",
                                class: "form-control TotProduct",
                                id: 'TotProduct'+j,
                                placeholder: "0",
                                value: producto.precio,
                                disabled: ""
                              }, null, 8, _hoisted_59)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("button", {
                              class: "btn btn-danger mt-3",
                              onClick: ($event: any) => (_ctx.EliminarProducto(j)),
                              type: "button "
                            }, _hoisted_63, 8, _hoisted_61)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _hoisted_64,
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("select", {
                    class: "form-select",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.TypePagos('TipoVen'))),
                    "aria-label": "Default select example",
                    id: "TipoVen"
                  }, _hoisted_71, 32)
                ]),
                _hoisted_72
              ]))
            : _createCommentVNode("", true),
          (_ctx.PagoEfectivo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "DineroEfect",
                    placeholder: "$0.00",
                    onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.LHAValidaNumerosDeci($event))),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.FormatoPN('DineroEfect','DineroCambio','TotalVent')))
                  }, null, 32)
                ]),
                _hoisted_78,
                (_ctx.HayCambio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("button", {
                          class: "btn btn-dark h-100",
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.Pagar()))
                        }, [
                          _hoisted_82,
                          _createTextVNode(" Pagar")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.PagoTarjeta)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("button", {
                    class: "btn btn-dark w-75",
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.Pagar()))
                  }, [
                    _hoisted_86,
                    _createTextVNode(" Pagar")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.Cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_87, _hoisted_89))
      : _createCommentVNode("", true),
    (_ctx.VerVentasPro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("i", {
              class: "bi bi-x-square-fill iconCerrar",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.CerrarVerVent()))
            }),
            _createElementVNode("div", _hoisted_92, [
              _hoisted_93,
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _hoisted_95,
                    _hoisted_96,
                    _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.dataVentas[_ctx.position].USU_NOMBRE), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _hoisted_99,
                    _hoisted_100,
                    _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_TIPOPAGO), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _hoisted_103,
                    _hoisted_104,
                    _createElementVNode("label", _hoisted_105, "$" + _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_MONTO), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _hoisted_107,
                    _hoisted_108,
                    _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_TIPOPAGO), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _hoisted_111,
                    _hoisted_112,
                    _createElementVNode("label", _hoisted_113, "$" + _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_MONTO), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _hoisted_116,
                _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_FECHA) + ".", 1)
              ]),
              (_ctx.dataVentas[_ctx.position].VEN_DESC!='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                    _hoisted_119,
                    _hoisted_120,
                    _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_DESC) + ".", 1)
                  ]))
                : _createCommentVNode("", true),
              (this.dataProVentaV.length!=0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                    _createElementVNode("table", _hoisted_123, [
                      _hoisted_124,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.dataProVentaV, (VenPro, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("th", _hoisted_125, [
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("label", _hoisted_127, _toDisplayString(i + 1), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("label", _hoisted_130, _toDisplayString(VenPro.nombre), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("label", _hoisted_133, _toDisplayString(VenPro.cantidad), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_134, [
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("label", _hoisted_136, "$" + _toDisplayString(VenPro.total), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.EditVentasPro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _createElementVNode("i", {
              class: "bi bi-x-square-fill iconCerrar",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.CerrarEditarVent()))
            }),
            _createElementVNode("div", _hoisted_139, [
              _hoisted_140,
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                    _hoisted_142,
                    _hoisted_143,
                    _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.dataVentas[_ctx.position].USU_NOMBRE), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_145, [
                _hoisted_146,
                _hoisted_147,
                _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_TIPOPAGO), 1)
              ]),
              _createElementVNode("div", _hoisted_149, [
                _hoisted_150,
                _hoisted_151,
                _createElementVNode("label", _hoisted_152, "$" + _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_MONTO), 1)
              ]),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                    _hoisted_154,
                    _hoisted_155,
                    _createElementVNode("label", _hoisted_156, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_FECHA) + ".", 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                    _hoisted_158,
                    _hoisted_159,
                    _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_FECHA) + ".", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_161, [
                _hoisted_162,
                _hoisted_163,
                (!_ctx.VerinputsEdit)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_164, _toDisplayString(_ctx.dataVentas[_ctx.position].VEN_DESC) + ".", 1))
                  : _createCommentVNode("", true),
                (_ctx.VerinputsEdit)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      class: "form-control",
                      id: "descEdit",
                      placeholder: "",
                      value: _ctx.dataVentas[_ctx.position].VEN_DESC 
                    }, null, 8, _hoisted_165))
                  : _createCommentVNode("", true)
              ]),
              (this.dataProVentaV.length!=0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                    _createElementVNode("table", _hoisted_167, [
                      _hoisted_168,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.dataProVentaV, (VenPro, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("th", _hoisted_169, [
                              _createElementVNode("div", _hoisted_170, [
                                _createElementVNode("label", _hoisted_171, _toDisplayString(i + 1), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_172, [
                              _createElementVNode("div", _hoisted_173, [
                                _createElementVNode("label", _hoisted_174, _toDisplayString(VenPro.nombre), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_175, [
                              _createElementVNode("div", _hoisted_176, [
                                _createElementVNode("label", _hoisted_177, _toDisplayString(VenPro.cantidad), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_178, [
                              _createElementVNode("div", _hoisted_179, [
                                _createElementVNode("label", _hoisted_180, "$" + _toDisplayString(VenPro.total), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("div", _hoisted_182, [
                  (_ctx.VerinputsEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary w-100",
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.GuardaEdit('descEdit')))
                      }, "Guardar"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.VerinputsEdit)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_183))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}